"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.randomBinary = exports.toBinary = void 0;
function toBinary(value) {
    var hex;
    if (value.startsWith("0x")) {
        hex = value.substring(2).toLowerCase();
    }
    else {
        hex = value.toLowerCase();
    }
    var re = /[0-9a-f]*/g;
    if (re.test(hex)) {
        return "0x" + hex;
    }
    throw new Error("not a binary: " + value);
}
exports.toBinary = toBinary;
function randomBinary(size) {
    return "0x" + Array.from(new Array(size * 2))
        .map(function () { return Math.floor(Math.random() * 16).toString(16); })
        .join("");
}
exports.randomBinary = randomBinary;
